var module = angular.module('octopusApp.library');

module.controller('FeedTestController', function($scope, $stateParams, $location, busy, octopusRepository) {
    var isLoading = $scope.isLoading = busy.create();
    var isTesting = $scope.isTesting = busy.create();

    var feedId = $stateParams["id"];

    $scope.feed = null;
    $scope.test = { searchTerm: null, started: false };
    $scope.packages = null;

    var repository = octopusRepository.Feeds;

    isLoading.promise(repository.get(feedId).then(function (feed) {
        $scope.feed = feed;
    }));

    $scope.hasVersion = function() {
        return $scope.feed && $scope.feed.FeedType !== "Docker";
    };

    $scope.testFeed = function() {
        $scope.test.started = true;
        $scope.packages = null;
        isTesting.promise(repository.search($scope.feed, {
            packageId: $scope.test.searchTerm,
            partialMatch: true,
            take: 10
        }).then(function(packages){
            $scope.packages = packages;
        }));
    };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/library/feeds/controllers/feed_test_controller.js
// module id = 7300215580116922
// module chunks = 1